/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BroadcastReminder } from '../../models/broadcast-reminder';
import { BroadcastReminderEmailResponse } from '../../models/broadcast-reminder-email-response';

export interface BroadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost$Params {
  org: string;
      body: BroadcastReminder
}

export function broadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost(http: HttpClient, rootUrl: string, params: BroadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost$Params, context?: HttpContext): Observable<StrictHttpResponse<BroadcastReminderEmailResponse>> {
  const rb = new RequestBuilder(rootUrl, broadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost.PATH, 'post');
  if (params) {
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BroadcastReminderEmailResponse>;
    })
  );
}

broadcastSubmissionRemindersToSuppliersApiV2MembersSuppliersSubmissionsBroadcastPost.PATH = '/api/v2/members/suppliers/submissions/broadcast';
